import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { kiZentraleApi } from '../api/kiZentraleApi';
import { useAuth } from './AuthContext';

const KiTodoContext = createContext();

export function KiTodoProvider({ children }) {
  const { user } = useAuth();
  const [todoCount, setTodoCount] = useState(0);

  const fetchTodoCount = useCallback(async () => {
    if (!user) {
      setTodoCount(0);
      return;
    }
    try {
      const data = await kiZentraleApi.getTodos();
      setTodoCount(data.counts?.alle || 0);
    } catch (error) {
      // Silently fail - user might not have access to KI Zentrale
    }
  }, [user]);

  useEffect(() => {
    fetchTodoCount();
    const interval = setInterval(fetchTodoCount, 30000);
    return () => clearInterval(interval);
  }, [fetchTodoCount]);

  const refreshTodoCount = useCallback(() => {
    fetchTodoCount();
  }, [fetchTodoCount]);

  // Sofort lokal dekrementieren (wie NotificationContext.decrementUnread)
  const decrementTodoCount = useCallback((amount = 1) => {
    setTodoCount(prev => Math.max(0, prev - amount));
  }, []);

  return (
    <KiTodoContext.Provider value={{ todoCount, refreshTodoCount, decrementTodoCount }}>
      {children}
    </KiTodoContext.Provider>
  );
}

export function useKiTodos() {
  const context = useContext(KiTodoContext);
  if (!context) {
    throw new Error('useKiTodos must be used within a KiTodoProvider');
  }
  return context;
}
